import { render, staticRenderFns } from "./custom-sorting.vue?vue&type=template&id=4523ff77"
import script from "./custom-sorting.vue?vue&type=script&lang=js"
export * from "./custom-sorting.vue?vue&type=script&lang=js"
import style0 from "./custom-sorting.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports